/**
 * Styles for the AitColumnAnnotationPreviewRow component
 */

.columnAnnotationCell {
  text-align: center;
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  vertical-align: top;
  padding: 0.25rem;
  position: relative;
  overflow: visible;
  min-height: 3rem; /* Reserve space to prevent collapse when preview expands */
}
